<script>
import directionIndicator from './directionIndicator.vue'
export default {
  template: `
    <div class='is-flex' :class='comparison?"is-justify-end":"is-justify-center"' style='width: 100%; height: 100%; align-items: center;'>
      <span :style='comparison?"margin-right: 15px":""' v-if='group === "CClimad"'>{{summary.total[group].p.toFixed(2)}}%</span>
      <div v-if='comparison'>
        <direction-indicator :tooltip='false' :w='25' :h='25' :nombrerangos='nameRanges' :rangos='getRange' :group='group' :summary='summary'></direction-indicator>
      </div>
    </div>
  `,
  data: function () {
    return {
      summary: {},
      group: '',
      comparison: false
    };
  },
  props: {
    nameRanges: {
      type: Object,
      required: true
    },
    getRange: {
      type: Function,
      required: true
    },
  },
  beforeMount() {
    const params = this.$parent.params;
    this.group = params.colDef.field
    this.summary = {
      total: params.data,
      processComp: {
        total: params.data.comparison
      }
    }
    this.comparison = Object.keys(this.summary.processComp.total).length
  },
  methods:{
  },
  components: {
    directionIndicator
  }
};

</script>
<style lang='scss'>

</style>



// WEBPACK FOOTER //
// src/components/climan/components/cellComparison.vue